export default "__VITE_ASSET__Db_6vULV__"